import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { TeflOlComment } from '../../../lib/types/models/tefl-ol-comment/tefl-ol-comment'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getTeflOlComments(input: PaginationRequest & { teflId: number }) {
  const { teflId, ...rest } = input

  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(
        constructApiUrl(API.tefl.getTeflOlComments.url, { teflId }),
        rest
      )
    )
    .get<PaginationResponse<TeflOlComment>>()
}
